import type { RetentionCell } from '../../services/analytics';
import { DASH, formatInt, formatPct } from './format';

/** "M0", "M1"... uma coluna por mes do periodo, a partir do mes de cadastro. */
export function retentionHeaders(months: string[]): string[] {
    return months.map((_, i) => `M${i}`);
}

export interface RetentionCellView {
    pct: string;
    count: string;
    /** 0 a 1: intensidade da cor do mapa de calor. */
    intensity: number;
}

/** Celula fechada mostra percentual e contas; mes em andamento ou sem safra vira traco. */
export function retentionCell(cell: RetentionCell | undefined): RetentionCellView | null {
    if (!cell || cell.pct === null) return null;
    return {
        pct: formatPct(cell.pct),
        count: `${formatInt(cell.count)} ${cell.count === 1 ? 'conta' : 'contas'}`,
        intensity: Math.max(0, Math.min(1, cell.pct / 100)),
    };
}

export const RETENTION_EMPTY = DASH;

export interface CohortCellView {
    count: string;
    pct: string;
    /** 0 a 1: intensidade da cor do mapa de calor. */
    intensity: number;
}

/** Coorte mostra o numero de contas em destaque e o percentual embaixo; mes aberto vira traco. */
export function cohortCell(cell: RetentionCell | undefined): CohortCellView | null {
    if (!cell || cell.pct === null) return null;
    return {
        count: formatInt(cell.count),
        pct: formatPct(cell.pct),
        intensity: Math.max(0, Math.min(1, cell.pct / 100)),
    };
}

/** "4 safras mensais"; no singular quando ha so uma. */
export function cohortSubtitle(months: number): string {
    return `${months} ${months === 1 ? 'safra mensal' : 'safras mensais'}`;
}

/** Cor do mapa de calor: a mesma da retencao geral. */
export function heatColor(intensity: number): string {
    return `color-mix(in srgb, var(--color-primary-600) ${Math.round(30 + intensity * 25)}%, var(--color-white))`;
}
